import { getValueFromFormState } from '../../../../helpers/formManager';
import { fieldNames } from '../../shared/configs/acceptanceForm';

export const startRules = {
  required: 'Укажите начальную дату',
  validate: (value, values) => {
    const acceptanceFrom = getValueFromFormState(
      values,
      fieldNames.main.fromDate
    );

    if (value && acceptanceFrom && value.isBefore(acceptanceFrom, 'day')) {
      return 'Начальная дата стола не может быть раньше начальной даты приемки';
    }
  },
};

export const endRules = {
  required: 'Укажите конечную дату',
  validate: (value, values) => {
    const acceptanceTo = getValueFromFormState(values, fieldNames.main.toDate);

    if (value && acceptanceTo && value.isAfter(acceptanceTo, 'day')) {
      return 'Конечная дата стола не может быть позже конечной даты приемки';
    }
  },
};
